import { useEffect, useRef } from "react"
import * as am5 from "@amcharts/amcharts5"
import * as am5percent from "@amcharts/amcharts5/percent"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import { Card, CardContent, Typography, Box } from "@mui/material"

export default function DonutChartComponent({ data, title = "Respuestas Seleccionadas" }) {
  const chartRef = useRef(null)

  useEffect(() => {
    if (!chartRef.current || !data || data.length === 0) return

    const root = am5.Root.new(chartRef.current)
    root.setThemes([am5themes_Animated.new(root)])

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(65),
      }),
    )

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
      }),
    )

    series.labels.template.setAll({
      text: '{category} {valuePercentTotal.formatNumber("0.00")}%',
      fontSize: 11,
      fill: am5.color(0x333333),
      radius: 20,
      textType: "circular",
    })

    series.slices.template.setAll({
      strokeWidth: 3,
      stroke: am5.color(0xffffff),
    })

    // Colores predefinidos para las categorías
    const predefinedColors = [
      0x5c9cdb, // Azul
      0xd77fb3, // Rosa
      0xc77fb3, // Rosa claro
      0x9c6fb8, // Púrpura claro
      0x7e5fb8, // Púrpura
      0x5e4fb8, // Púrpura oscuro
      0x4caf50, // Verde
      0xff9800, // Naranja
      0xf44336, // Rojo
      0x00bcd4, // Cyan
    ]

    // Transformar los datos del formato recibido al formato que espera amCharts
    const chartData = data.map((item, index) => ({
      category: item.category,
      value: item.percentage,
      count: item.count,
      color: am5.color(predefinedColors[index % predefinedColors.length]),
    }))

    series.slices.template.adapters.add("fill", (fill, target) => {
      const dataItem = target.dataItem
      return dataItem?.dataContext?.color || fill
    })

    series.data.setAll(chartData)
    series.appear(1000, 100)

    return () => {
      root.dispose()
    }
  }, [data])

  return (
    <Card sx={{ boxShadow: 2, height: "100%" }}>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: "16px" }}>
            {title}
          </Typography>
        </Box>
        <div ref={chartRef} style={{ width: "100%", height: "380px" }} />
      </CardContent>
    </Card>
  )
}